import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reset } from 'redux-form'
import { push } from 'connected-react-router'
import { notification } from 'redux/modules/app'
import { registrations as registrationsApi } from 'redux/modules/api'
import { get } from 'lodash'

function decorator () {
  return ComposedComponent => {
    @connect(
      state => ({
        registrations: state.api.registrations
      }),
      {
        ...registrationsApi,
        notification,
        push,
        reset
      }
    )
    class Registrations extends Component {
      static propTypes = {
        registrations: PropTypes.object.isRequired,
        getRegistrationInitData: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        formValues: PropTypes.object
      }

      handleError = err => {
        console.debug('error', get(err, 'body.userMessage'))
        this.props.notification(get(err, 'body.userMessage'), 'error')
        throw err
      }

      handleGetRegistrationInitData = globalId => {
        const data = { 'globalId': globalId }

        return this.props.getRegistrationInitData(data)
          .catch(this.handleError)
      }

      render () {
        return (
          <ComposedComponent
            {...this.props}
            onGetRegistrationInitData={this.handleGetRegistrationInitData}

          />
        )
      }
    }

    return Registrations
  }
}

export default decorator
